export default __webpack_public_path__ + "static/media/us2nigeria_logo_Resised.87234dd8.png";